jQuery(($) => {
	// Au scroll faire apparaitre ou disparaitre le bouton de retour en haut de page
	$(window).on('scroll', () => {
		const $back = $('.back-to-top')
		const duration = 600
		const posScroll = $(document).scrollTop()

		if (posScroll >= 550) {
			$back.fadeIn(duration)
		} else {
			$back.fadeOut(duration)
		}
	})

	$('.back-to-top').on('click', (event) => {
		event.preventDefault()
		$('html, body').animate({scrollTop: 0}, 500)
	})
})
